import { storageService } from '@/services'
import { isNullOrUndefined, isObject } from '~/util/validators/baseComponentsValidators'

export default ({ app: { store, router, $newModal } }) => {
  router.beforeEach((to, from, next) => {

    // Условие, когда нужно показать модалку
    const condition = !store.getters['user/isUserVerified'] && store.getters['user/user'].payin_count !== 0

    const needsConfirmation = to.path.includes('cashbox')
      && !!from.name
      && (!!!from.query.modal || !from.query.modal === 'verify-before-pay')
      && !from.path.includes('cashbox')
      && condition

    if (!needsConfirmation) {
      return next()
    }

    // Прерываем навигацию и показываем модалку
    next(false)

    // Открываем модалку
    store.dispatch('globalModal/open_globalModalVerifyBeforePay')
  })

  router.afterEach((to, _from) => {
    if (to.query.refcode && storageService.getToken()) {
      storageService.setAffise(to.query.refcode)
    }
    if (~to.fullPath.indexOf('utm')) {
      const fullPath = to.fullPath
      const expDate = new Date()
      const domain = window.location.hostname
      const utm = fullPath.slice(fullPath.indexOf('utm'))

      expDate.setHours(expDate.getHours() + 24)
      storageService.setItem('utm', utm, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('refcode')) {
      const expDate = new Date()
      expDate.setDate(expDate.getDate() + 1)
      const refCode = to.query.refcode
      const subId = to.query.hasOwnProperty('subid') ? to.query.subid : ''
      const referer = document.referrer
      let domain = window.location.hostname
      const chunks = domain.split('.')
      if (chunks.length > 1) domain = chunks.slice(-2).join('.')

      storageService.setItem('adw_refcode', refCode, expDate, '/', domain)
      storageService.setItem('adw_subid', subId, expDate, '/', domain)
      storageService.setItem('adw_referer', referer, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('stag')) {
      const expDate = new Date()
      expDate.setDate(expDate.getDate() + 1)
      const stag = to.query.stag
      let domain = window.location.hostname
      const chunks = domain.split('.')
      if (chunks.length > 1) {
        domain = chunks.slice(-2)
          .join('.')
      }
      storageService.setItem('stag', stag, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('promoCode') && !to.fullPath.includes('PPCode')) {
      const routerQuery = { ...to.query }
      const expDate = new Date()
      const domain = window.location.hostname
      const promoCode = routerQuery.promoCode

      delete routerQuery.promoCode

      if (storageService.getToken()) {
        router.replace({ query: routerQuery })
      }
      else {
        $newModal.openAuthOrRegister({ noOldQuery: true, id: 'router-tracker' })
      }
      expDate.setFullYear(expDate.getFullYear() + 1)
      storageService.setItem('promoCode', promoCode, expDate, '/', domain)
    }
    if (to.fullPath.includes('PPCode')) {
      // promoCode example: PPCode5_ABCDE
      const promoUrl = to.fullPath
      const indexOfPromoCode = +promoUrl.indexOf('PPCode')
      const totalCharactersInPromoCode = +promoUrl.at(indexOfPromoCode + 6)
      const indexOfFirstPromoCodeCharacter = indexOfPromoCode + 8
      const promoCode = promoUrl.slice(indexOfFirstPromoCodeCharacter, indexOfFirstPromoCodeCharacter + totalCharactersInPromoCode)

      const routerQuery = { ...to.query }
      Object
        .keys(routerQuery)
        .map((value) => {
          if (routerQuery[value] && routerQuery[value].includes('PPCode')) {
            delete routerQuery[value]
          }
        })
      router.push({ query: routerQuery })

      const expDate = new Date()
      const domain = window.location.hostname
      expDate.setFullYear(expDate.getFullYear() + 1)
      storageService.setItem('promoCode', promoCode, expDate, '/', domain)
    }
    if (storageService.getItem('token') && storageService.getItem('utm')) {
      store.dispatch('user/SEND_UTM', storageService.getItem('utm'))
      storageService.removeItem('utm')
    }
  })
}
